// extracted by mini-css-extract-plugin
export default {"h1":"htag_h1__aFkuR","h2":"htag_h2__FYSBP","h3":"htag_h3__pXvvq","h4":"htag_h4__Wh+Ea"};